import React from 'react';
import { AdPlaceholder } from '../shared/AdPlaceholder';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy, faClipboard, faTheaterMasks, faFire, faMoneyBill, faClover } from '@fortawesome/free-solid-svg-icons';

interface GuideScreenProps {
    onBack: () => void;
}

export const GuideScreen: React.FC<GuideScreenProps> = ({ onBack }) => {
    return (
        <>
            <AdPlaceholder />
            <div className="guide-screen-container">
                <h1>Game Guide</h1>
            
            <div className="panel">
                <div className="panel-header"><FontAwesomeIcon icon={faTrophy} style={{ color: 'var(--warning-color)', marginRight: '8px' }} /> Your Goal: The Road to Glory</div>
                <div className="panel-content">
                    <p>Welcome, gaffer! 🎯 Your mission is to take a randomly assigned team from the bottom of the football pyramid and lead them all the way to the top. Win leagues, claim cup trophies, build legends, and create a dynasty that will be remembered. It's challenging, rewarding, and absolutely thrilling!</p>
                </div>
            </div>

            <div className="panel">
                <div className="panel-header"><FontAwesomeIcon icon={faClipboard} style={{ color: 'var(--info-color)', marginRight: '8px' }} /> Building Your Dynasty</div>
                <div className="panel-content">
                    <ul>
                        <li><strong>Tactics:</strong> Pick a formation and mentality on the Tactics screen. The right tactics can turn a decent team into a powerhouse! Use the AI Assistant Manager to get recommendations if you're unsure.</li>
                        <li><strong>Player Development:</strong> Every player has 'Skill' (current ability) and 'Potential' (their ceiling). Invest in young talents with <span className="potential-badge potential-elite">ELITE</span> or <span className="potential-badge potential-star">STAR</span> potential badges - they'll grow into superstars!</li>
                        <li><strong>Transfers:</strong> The transfer market is your playground for building a winning squad. Scout for hidden gems, develop young players, and sell them at a profit. Smart trading can fund your dynasty!</li>
                    </ul>
                </div>
            </div>

            <div className="panel">
                <div className="panel-header"><FontAwesomeIcon icon={faTheaterMasks} style={{ color: 'var(--accent-color)', marginRight: '8px' }} /> Experience the Drama</div>
                <div className="panel-content">
                    <ul>
                        <li><strong>Player Morale:</strong> Your squad is made of real personalities with real emotions. Keep them happy and they'll run through walls for you. Let morale slip and watch team chemistry fall apart. Manage morale conversations wisely!</li>
                        <li><strong>Giant Killings:</strong> Pull off a miracle cup upset against a bigger, richer team and watch the football world celebrate your underdog victory! These moments are what football is all about.</li>
                        <li><strong>Club Legends:</strong> Players who serve your club with distinction will be immortalized in your 'Manager &gt; Club Records' Hall of Fame. Create a legacy players dream of joining.</li>
                        <li><strong>Awards & Recognition:</strong> At season's end, your top performer receives the 'Player of the Season' award. Top managerial achievements unlock special badges and reputation!</li>
                    </ul>
                </div>
            </div>

            <div className="panel">
                <div className="panel-header"><FontAwesomeIcon icon={faFire} style={{ color: 'var(--negative-color)', marginRight: '8px' }} /> Ready for an Extra Challenge?</div>
                <div className="panel-content">
                    <p>Want to test yourself harder? Try one of our <strong>Challenge Modes</strong> from the start screen! 💪 Escape relegation against all odds (Great Escape), build a title-winning team with only youth players (Youth Academy), or rescue a club drowning in debt (Debt Crisis). Each mode offers unique thrills!</p>
                </div>
            </div>

            <div className="panel">
                <div className="panel-header"><FontAwesomeIcon icon={faMoneyBill} style={{ color: 'var(--positive-color)', marginRight: '8px' }} /> Master Your Finances</div>
                <div className="panel-content">
                    <p>Smart finance management is essential! Player wages and transfer fees can pile up fast. Monitor your budget, make smart sales, and never overspend. If your bank account goes negative... 💥 <strong>Game Over!</strong> But with clever trading, you can build a profitable empire!</p>
                </div>
            </div>

            <div className="panel">
                <div className="panel-header"><FontAwesomeIcon icon={faClover} style={{ color: 'var(--positive-color)', marginRight: '8px' }} /> Good Luck, Gaffer! 🍀</div>
                <div className="panel-content">
                    <p>The journey to glory is long, unpredictable, and absolutely thrilling. There will be triumphs and heartbreaks, but that's what makes it beautiful. Can you handle the pressure and build a dynasty? The pitch is yours. Now get out there and make your mark! 🏆</p>
                </div>
            </div>

                <button className="button primary" onClick={onBack}>Back</button>
            </div>
        </>
    );
};
